import {
    CREATE_CHECKOUT_ORDER_FAILURE,
    CREATE_CHECKOUT_ORDER_START,
    CREATE_CHECKOUT_ORDER_SUCCESS,
    GET_CHECKOUT_ORDER_FAILURE,
    GET_CHECKOUT_ORDER_START,
    GET_CHECKOUT_ORDER_SUCCESS,
} from "./ActionConstant";

export function createCheckoutOrderStart(data) {
    return {
        type: CREATE_CHECKOUT_ORDER_START,
        data,
    };
}

export function createCheckoutOrderSuccess(data) {
    return {
        type: CREATE_CHECKOUT_ORDER_SUCCESS,
        data,
    };
}

export function createCheckoutOrderFailure(error) {
    return {
        type: CREATE_CHECKOUT_ORDER_FAILURE,
        error,
    };
}

export function getCheckoutOrderStart(data) {
    return {
        type: GET_CHECKOUT_ORDER_START,
        data,
    };
}

export function getCheckoutOrderSuccess(data) {
    return {
        type: GET_CHECKOUT_ORDER_SUCCESS,
        data,
    };
}

export function getCheckoutOrderFailure(error) {
    return {
        type: GET_CHECKOUT_ORDER_FAILURE,
        error,
    };
}